import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { money } from "@/lib/academyFormat";
import { ACADEMY } from "@/constants/testIds";

// Fix U (2026-10-13): plan de pagos a medida: cuotas con fecha y monto.
export default function PlanEditor({ value, onChange, total }) {
  const rows = value || [];
  const sum = rows.reduce((s, r) => s + (Number(r.amount) || 0), 0);
  const update = (i, k, v) => onChange(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  return (
    <div className="space-y-2" data-testid={ACADEMY.planEditor}>
      {rows.map((r, i) => (
        <div key={i} className="grid grid-cols-[1fr_1fr_auto] gap-2 items-center">
          <Input type="date" value={r.due_date} onChange={(e) => update(i, "due_date", e.target.value)} data-testid={`${ACADEMY.planDatePrefix}${i}`} />
          <Input type="number" min="0" step="0.01" value={r.amount} onChange={(e) => update(i, "amount", e.target.value)} placeholder="Monto" data-testid={`${ACADEMY.planAmountPrefix}${i}`} />
          <Button type="button" variant="ghost" size="icon" onClick={() => onChange(rows.filter((_, j) => j !== i))}><Trash2 className="w-4 h-4 text-destructive" /></Button>
        </div>
      ))}
      <div className="flex items-center justify-between">
        <Button type="button" variant="outline" size="sm" onClick={() => onChange([...rows, { due_date: "", amount: "" }])} data-testid={ACADEMY.planAddButton}>
          <Plus className="w-4 h-4" /> Agregar cuota
        </Button>
        {rows.length > 0 && (
          <span className={`text-xs ${total != null && Math.abs(sum - total) > 0.005 ? "text-[#A34B49]" : "text-muted-foreground"}`}>
            Suma {money(sum)}{total != null ? ` de ${money(total)}` : ""}
          </span>
        )}
      </div>
    </div>
  );
}

export function cleanPlan(rows) {
  return (rows || [])
    .filter((r) => r.due_date && Number(r.amount) > 0)
    .map((r) => ({ due_date: r.due_date, amount: Number(r.amount), note: r.note || null }));
}
